export default __webpack_public_path__ + "images/S0.d539770.png";